import React from "react";

const WrongAnswerAudio = () => {
  return (
    <audio id="backgroundMusic" autoPlay>
      <source src="/assets/music/wrong.mp3" type="audio/mp3" />
    </audio>
  );
};

export default WrongAnswerAudio;